exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iti--separate-dial-code .iti__flag-container[data-v-a70201b8]{left:0;right:auto;direction:ltr}.fetchingIcon[data-v-a70201b8],.mobileDoesNotExistIcon[data-v-a70201b8],.mobileExistsIcon[data-v-a70201b8]{float:right;margin-right:10px;margin-top:-27px;position:relative;z-index:2;cursor:default}.mobileInvalid[data-v-a70201b8]{color:red;margin-top:5px}.mobileExistsIcon[data-v-a70201b8]{color:red}.mobileExistsText[data-v-a70201b8]{color:red;margin-top:5px}.mobileDoesNotExistIcon[data-v-a70201b8]{color:green}", ""]);

// exports
